<template>
  <div class="stream-tab-body">
    <div class="stream-tab-body-header">
      <span class="stream-status-label"> Stream Connection Average Status:</span>
      <div class="stream-status" v-if="stream_status == 'live'">
        <b-tag :type="streamHealthTagType">{{ streamHealthStatus }}</b-tag>
      </div>
      <div class="stream-status" v-else>
        <b-tag type="is-warning">Disconnected</b-tag>
      </div>
    </div>
    <div class="stream-tab-body-body">
      <div class="stream-details-header" v-if="stream_status == 'live'">Incoming stream details</div>
      <div class="stream-details" v-if="healthData && stream_status == 'live'">
        <div class="stream-detail-item">
          <div class="stream-detail-item-label">Video Width</div>
          <div class="stream-detail-item-value">{{ healthData.videoWidth }}</div>
        </div>
        <div class="stream-detail-item">
          <div class="stream-detail-item-label">Video Height</div>
          <div class="stream-detail-item-value">{{ healthData.videoHeight }}</div>
        </div>
        <div class="stream-detail-item">
          <div class="stream-detail-item-label">Video Codec</div>
          <div class="stream-detail-item-value">{{ healthData.videoCodecName }}</div>
        </div>
        <div class="stream-detail-item">
          <div class="stream-detail-item-label">Video Fps </div>
          <div class="stream-detail-item-value">{{ healthData.videoFps }}</div>
        </div>
        <div class="stream-detail-item">
          <div class="stream-detail-item-label">Audio Codec</div>
          <div class="stream-detail-item-value">{{ healthData.audioCodecName }}</div>
        </div>
        <div class="stream-detail-item">
          <div class="stream-detail-item-label">Audio Sample Rate</div>
          <div class="stream-detail-item-value">{{ healthData.audioSamplerate }}</div>
        </div>
        <div class="stream-detail-item">
          <div class="stream-detail-item-label">Audio Channels</div>
          <div class="stream-detail-item-value">{{ healthData.audioChannels }}</div>
        </div>
        <div class="stream-detail-item">
          <div class="stream-detail-item-label">Audio Profile</div>
          <div class="stream-detail-item-value">{{ healthData.audioProfileName }}</div>
        </div>
      </div>
      <div class="stream-health-header">Stream Health</div>
      <div class="stream-health-body-chart">

        <WidgetChart :height="90" ref="healthChart" :pushDataFn="pushDataFn" :chartBgColor="updateChartColor">
        </WidgetChart>

      </div>
    </div>
  </div>
</template>

<script>
import WidgetChart from "@/components/widget/widgetChart.vue";
export default {
  components: { WidgetChart },
  props: {
    event: {
      type: Object,
      required: true,
    },
    streamKey: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    }
  },
  data: () => ({
    healthData: null,
    healthLogs: [],
    isStarted: false,
  }),
  watch: {
  },
  mounted() {
    let vm = this;
  },
  methods: {
    pushDataFn(dataset) {
      let vm = this;
      if (vm.status !== 'live') {
        dataset.push({
          x: Date.now(),
          y: 0
        });
        vm.healthLogs = [];
        return;
      }
      if (!vm.isStarted) {
        dataset.push({
          x: Date.now(),
          y: 0
        });
        vm.isStarted = true;
      }
      vm.fetchAndUpdateChart(dataset);
    },

    fetchAndUpdateChart(dataset) {
      let vm = this;
      vm.$store.dispatch("STREAMING_GET_STREAM_HEALTH", {
        stream_id: vm.event.id,
        stream_key: vm.streamKey,
        sessionId: vm.event.session_id,
      }).then((response) => {
        const result = response.data;
        vm.healthData = result.streamHealth;
        vm.healthLogs = process.env.NODE_ENV === 'development' ? vm.healthData.healthLogs : JSON.parse(vm.healthData.healthLogs);

        if (!Array.isArray(vm.healthLogs)) {
          console.error("Parsed healthLogs is not an array:", vm.healthLogs);
          return;
        }

        vm.healthLogs.sort((a, b) => new Date(a.time) - new Date(b.time));
        const lastHealthLog = vm.healthLogs[vm.healthLogs.length - 1];
        dataset.push({
          x: Date.now(),
          y: lastHealthLog.bitrate > 2500 ? 2500 : lastHealthLog.bitrate
        });

      }).catch((error) => {
        console.error("Error fetching stream health:", error);
      });
    },
  },
  computed: {
    streamHealthStatus() {
      let vm = this;
      if (vm.healthLogs.length > 0) {
        const relevantData = vm.healthLogs.map(item => item.bitrate).slice(-15);
        const averageBitrate = relevantData.reduce((a, b) => a + b, 0) / relevantData.length;
        if (averageBitrate > 2100) {
          return 'Excellent';
        } else if (averageBitrate > 1800) {
          return 'Good';
        } else if (averageBitrate > 1500) {
          return 'Fair';
        } else {
          return 'Poor';
        }
      }
      return 'N/A';
    },
    streamHealthTagType() {
      switch (this.streamHealthStatus) {
        case 'Excellent': return 'is-success';
        case 'Good': return 'is-success is-light';
        case 'Fair': return 'is-warning';
        case 'Poor': return 'is-danger';
        default: return 'is-grey'; // Use a neutral color for N/A
      }
    },
    updateChartColor() {
      let newColor;
      switch (this.streamHealthStatus) {
        case 'Excellent':
          newColor = '#4CAF50'; // Green
          break;
        case 'Good':
          newColor = '#81C784'; // Lighter Green
          break;
        case 'Fair':
          newColor = '#FFB74D'; // Orange
          break;
        case 'Poor':
          newColor = '#E57373'; // Red
          break;
        default:
          newColor = '#9E9E9E'; // Grey for N/A or disconnected
      }
      return newColor;
    },
    stream_status() {
      let vm = this;
      return vm.status;
    }
  },
};
</script>
<style lang="scss" scoped>
.stream-tab-body {
  height: calc(100% - 400px);
  width: 100%;
  display: flex;
  flex-direction: column;

  .stream-tab-body-header {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    border-bottom: 1px solid #ddd;
    height: 65px;

    .stream-status-label {
      margin-right: 10px;
    }
  }

  .stream-tab-body-body {
    height: calc(100% - 65px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    .stream-details-header {
      font-size: 16px;
      padding: 10px 20px;
      color: #333;
    }

    .stream-details {
      padding: 10px 20px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;

      .stream-detail-item {
        display: flex;
        justify-content: space-between;
        padding: 10px 10px;
        border: 1px solid #ddd;
        border-radius: 5px;

        .stream-detail-item-label {
          color: #666;
        }

        .stream-detail-item-value {
          color: #333;
        }
      }
    }

    .stream-health-header {
      font-size: 16px;
      padding: 10px 20px;
      color: #333;
    }
  }
}
</style>